import React from "react";

const TopBody = () => {
  return (
    <div className="row">
      <div className="col shop-cart">
        <h1>Shopping Cart</h1>
      </div>
    </div>
  );
};

export default TopBody;
